export const COMPACT_POPOVER_CONTENT_CLASS = 'p-1'

export const VIEW_PARAMETER_DROPDOWN_FRAME_CLASS =
  'overflow-hidden rounded-md border border-default surface-default p-1 shadow-md'

/** Literal CSS pixels between adjacent options; mirrors --menu-option-gap. */
export const MENU_OPTION_GAP_PX = 1
export const COMPACT_OPTION_LIST_GAP_CLASS = 'gap-[var(--menu-option-gap)]'
/** Apply to the direct parent of rows, inside any scroll container padding. */
export const MENU_OPTION_LIST_CLASS = `flex flex-col ${COMPACT_OPTION_LIST_GAP_CLASS} [&>*]:shrink-0`
export const VIEW_PARAMETER_DROPDOWN_LIST_CLASS = MENU_OPTION_LIST_CLASS
export const VIEW_PARAMETER_DROPDOWN_SCROLLBAR_GUTTER_CLASS = '-my-1 -mr-1 py-1 pr-1'
export const VIEW_PARAMETER_DROPDOWN_TRAILING_SCROLLBAR_GUTTER_CLASS = '-mb-1 -mr-1 pb-1 pr-1'

/** Layout only: each row sets its own text color, so an active row's color isn't outranked. */
export const VIEW_PARAMETER_FIELD_OPTION_CLASS =
  'flex w-full items-center gap-1 rounded-md px-1 py-1.5 text-view-parameter-control'

export const VIEW_PARAMETER_VALUE_OPTION_CLASS =
  'flex w-full items-center gap-1.5 rounded-md px-3 py-1.5 text-view-parameter-control text-default'

export const VIEW_PARAMETER_EMPTY_VALUE_OPTION_CLASS =
  'flex min-h-8 w-full items-center gap-1.5 rounded-md px-3 py-1.5 text-view-parameter-control text-default'

export const COMPACT_POPOVER_MENU_ROW_CLASS =
  'flex w-full items-center gap-1.5 rounded-md px-3 py-1.5 text-left text-view-parameter-control transition-colors'
